import React, { useLayoutEffect, useRef } from 'react';

import { fmt_count } from '../../format';
import { MAX_RUN_TEACHERS } from './params';

const SelectionBar = ({
  shown_count,
  shown_picked,
  picked_count,
  matching,
  match_all,
  noun,
  match_verb = 'Select',
  locked = false,
  on_toggle_shown,
  on_match_all,
  on_clear
}) => {
  const box_ref = useRef(null);
  const all_shown = shown_count > 0 && shown_picked === shown_count;
  const some_shown = shown_picked > 0 && !all_shown;
  useLayoutEffect(() => {
    if (box_ref.current) box_ref.current.indeterminate = some_shown && !match_all;
  }, [some_shown, match_all]);

  const can_match = !match_all && matching !== null && matching > 0;
  const selected = match_all ? match_all.count : picked_count;

  return (
    <div>
      <div className="tp-frow">
        <label className="tp-na-row-main">
          <input
            ref={box_ref}
            type="checkbox"
            checked={!!match_all || all_shown}
            onChange={on_toggle_shown}
            disabled={locked || !!match_all || shown_count === 0}
          />
          <span>Select all shown ({fmt_count(shown_count)})</span>
        </label>
        {can_match && matching <= MAX_RUN_TEACHERS ? (
          <button type="button" className="tp-btn-ghost" onClick={on_match_all} disabled={locked}>
            {match_verb} all {fmt_count(matching)} matching
          </button>
        ) : null}
        {can_match && matching > MAX_RUN_TEACHERS ? (
          <span className="tp-card-hd-sub">
            {fmt_count(matching)} match; one run takes at most {fmt_count(MAX_RUN_TEACHERS)}. Narrow
            the search.
          </span>
        ) : null}
        {selected ? (
          <button type="button" className="tp-btn-ghost" onClick={on_clear} disabled={locked}>
            Clear selection
          </button>
        ) : null}
        <span className="tp-card-hd-sub">{fmt_count(selected)} selected</span>
      </div>
      {match_all ? (
        <div className="tp-banner tp-banner-info" role="status">
          All {fmt_count(match_all.count)} {noun} matching this list are selected. The list is fixed
          when the run starts.
        </div>
      ) : null}
    </div>
  );
};

export default SelectionBar;
